import styled, { css } from 'react-emotion'

export const CarouselWrapper = styled('div')`
  // overflow: hidden;
  // margin: 0.5rem;
  padding: 1rem 0 0 !important;
  height: ${props => props.height || 'auto'};
  min-height: ${props => props.minHeight || '300px'};

  .slider-slide:hover .imageWrapper.loaded .imageBorder {
    opacity: 1;
    transition: opacity 0.3s;
  }

  .slider-slide:hover .imageWrapper .bannerImage {
    transform: scale(1.03);
    transition: all 0.3s;
    cursor: pointer;
  }

  .slider-frame {
    padding: 0 !important;
    min-height: ${props => (props.isResized ? '0!important' : 'auto')};
  }

  .slider-control-centerright {
    right: -2.5% !important;
  }

  .slider-control-centerleft {
    left: -2.5% !important;
  }

  @media screen and (max-width: 1024px) {
    // min-height: 14rem;

    .slider-control-centerright {
      right: -2.5rem !important;
    }

    .slider-control-centerleft {
      left: -2.5rem !important;
    }

    .slider-control-centerleft .arrowWrapper {
      left: -0.5rem;
    }

    .slider-control-centerright .arrowWrapper {
      right: 0;
    }

    .slider-control-centerright span {
      right: -1.2rem;
    }
  }

  @media screen and (max-width: 640px) {
    // min-height: 14rem;
    padding: ${props => (props.noPaddingMobile ? '1rem 0 0 !important' : '1rem 0.5rem 0 !important')};

    .slider-control-centerright {
      right: -2.5rem !important;
    }

    .slider-control-centerright .arrowWrapper {
      right: 0;
    }

    .slider-control-centerleft .arrowWrapper {
      left: -0.7rem;
    }

    .slider-control-centerleft {
      left: -2.5rem !important;
    }

    .slider-control-centerright span,
    .slider-control-centerleft span {
      width: 1.5rem;
    }

    .slider-control-centerright span {
      right: 0;
    }
  }

  @media screen and (min-width: 1600px) {
    .slider-control-centerright {
      right: -1.8% !important;
    }

    .slider-control-centerleft {
      left: -1.8% !important;
    }
  }
`
